import { render } from "./Help.vue?vue&type=template&id=2acfc91c"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/Help.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2acfc91c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2acfc91c', __exports__)) {
    api.reload('2acfc91c', __exports__)
  }
  
  module.hot.accept("./Help.vue?vue&type=template&id=2acfc91c", () => {
    api.rerender('2acfc91c', render)
  })

}


export default __exports__